import { RgChildren as i } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as l } from "../../../utils/rg-util/index3.js";
import { isBaseBuildObject as o } from "../../queries/index2.js";
import { getVerticalWallArea as a } from "../total-metrics/index59.js";
const B = (e, r) => {
  const t = l(e, i.Building, r).filter(o);
  return a(t);
};
export {
  B as getLevelBaseBuildWallArea
};
//# sourceMappingURL=index8.js.map
